import { useParams } from 'react-router-dom';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import { Loader } from '../../../../../../components';
import { format, parseISO } from 'date-fns';
import useGetScriptExecutionDetails
  from '../../../../../../queries/scriptExecutionDetails/useGetScriptExecutionDetails';

const fieldsToRender = [
  { key: 'fileName', label: 'Script Name' },
  { key: 'sha256Hash', label: 'SHA256 Hash' },
  { key: 'deviceCount', label: 'Device Count' },
  { key: 'firstSeen', label: 'First Seen' },
  { key: 'lastUpdated', label: 'Last Updated' },
];

const Container = ({ children }) => (
  <Box
    sx={theme => ({
      backgroundColor: '#484848',
      boxShadow: '0px 1px 2px 0px #64748B1A',
      borderRadius: theme.spacing(1),
      padding: '32px 24px',
      width: '100%',
    })}>
    {children}
  </Box>
);
const ScriptExecutionDetails = () => {
  const { scriptExecutionId } = useParams();
  const { isLoading, data: scriptExecutionDetails } = useGetScriptExecutionDetails({ scriptExecutionId });

  const getCellValue = (key) => {

    if (key === 'firstSeen') {
      return scriptExecutionDetails.firstSeen
        ? format(parseISO(scriptExecutionDetails.firstSeen), 'yyyy-MM-dd')
        : 'no data';
    }
    if (key === 'lastUpdated') {
      return scriptExecutionDetails.lastUpdated
        ? format(parseISO(scriptExecutionDetails.lastUpdated), 'yyyy-MM-dd')
        : 'no data';
    }

    return scriptExecutionDetails[key] ?? 'no data';
  };

  if (isLoading) {
    return (
      <Box mt={'80px'}>
        <Loader />
      </Box>
    );
  }

  return (
    <Container>
      <Stack spacing={2}>
        <Table>
          <TableBody>
            {fieldsToRender.map(({ key, label }) => (
              <TableRow key={key}>
                <TableCell>{label}:</TableCell>
                <TableCell>
                  {getCellValue(key)}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Stack>
    </Container>
  );
};

export default ScriptExecutionDetails;
